/* Wallspoke — tap a cart line's design to open it full screen and zoom in.
 *
 * Source of truth lives in the app repo at docs/cart-preview-zoom.js. Edit it there
 * and copy across, so the two cannot drift.
 *
 * Binds to [data-ws-zoom], which sections/main-cart.liquid sets on the line image.
 * Delegated from the document, so it survives the cart re-rendering after a quantity
 * change - a directly bound listener would be lost each time.
 *
 * /p/<id>.png is rendered with a 2000px long edge, so there is genuine detail to open
 * up. The customer is checking they picked the right design; let them see the street
 * names.
 */
(function () {
  if (window.__wsZoomReady) return;          // a theme that includes this twice
  window.__wsZoomReady = true;

  var MAX = 6, MIN = 1;
  var overlay, img, scale = 1, tx = 0, ty = 0;
  var dragging = false, lastX = 0, lastY = 0, pinchStart = 0, scaleStart = 1;

  function css() {
    var s = document.createElement('style');
    s.textContent =
      '.ws-zoom-ov{position:fixed;inset:0;z-index:2147483646;background:rgba(20,19,17,.92);' +
      'display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .16s ease;' +
      'touch-action:none;overscroll-behavior:contain;cursor:zoom-out}' +
      '.ws-zoom-ov.on{opacity:1}' +
      '.ws-zoom-ov img{max-width:92vw;max-height:88vh;transform-origin:center center;' +
      'will-change:transform;user-select:none;-webkit-user-drag:none;box-shadow:0 10px 50px rgba(0,0,0,.5)}' +
      '.ws-zoom-x{position:absolute;top:14px;right:16px;width:40px;height:40px;border:0;border-radius:50%;' +
      'background:rgba(255,255,255,.14);color:#fff;font:300 24px/1 system-ui,sans-serif;cursor:pointer}' +
      '.ws-zoom-x:hover{background:rgba(255,255,255,.24)}' +
      '.ws-zoom-hint{position:absolute;bottom:18px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,.72);' +
      'font:13px/1.4 system-ui,sans-serif;letter-spacing:.02em;pointer-events:none}';
    document.head.appendChild(s);
  }

  function apply() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }

  function reset() { scale = 1; tx = 0; ty = 0; apply(); }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('on');
    document.documentElement.style.overflow = '';
    var o = overlay; overlay = null; img = null;
    setTimeout(function () { try { o.remove(); } catch (e) {} }, 180);
  }

  function zoomAt(factor, cx, cy) {
    var next = Math.min(MAX, Math.max(MIN, scale * factor));
    if (next === scale) return;
    // keep the point under the cursor/fingers put as the image grows
    var r = img.getBoundingClientRect();
    var ox = cx - (r.left + r.width / 2);
    var oy = cy - (r.top + r.height / 2);
    var k = next / scale;
    tx = tx - ox * (k - 1);
    ty = ty - oy * (k - 1);
    scale = next;
    if (scale === MIN) { tx = 0; ty = 0; }
    apply();
  }

  function open(src) {
    close();
    overlay = document.createElement('div');
    overlay.className = 'ws-zoom-ov';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Your design, enlarged');
    overlay.innerHTML =
      '<button class="ws-zoom-x" aria-label="Close">×</button>' +
      '<img alt="Your custom design">' +
      '<div class="ws-zoom-hint">Scroll or pinch to zoom · drag to pan</div>';
    img = overlay.querySelector('img');
    img.src = src;
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';   // no scrolling the page behind
    reset();
    requestAnimationFrame(function () { overlay.classList.add('on'); });

    overlay.querySelector('.ws-zoom-x').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    img.addEventListener('dblclick', function (e) {
      e.preventDefault();
      if (scale > MIN) reset(); else zoomAt(2.5, e.clientX, e.clientY);
    });

    overlay.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomAt(e.deltaY < 0 ? 1.12 : 1 / 1.12, e.clientX, e.clientY);
    }, { passive: false });

    img.addEventListener('pointerdown', function (e) {
      if (scale <= MIN) return;
      dragging = true; lastX = e.clientX; lastY = e.clientY;
      try { img.setPointerCapture(e.pointerId); } catch (err) {}
    });
    img.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      tx += e.clientX - lastX; ty += e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY; apply();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      img.addEventListener(t, function () { dragging = false; });
    });

    // pinch
    overlay.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      pinchStart = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                              e.touches[0].clientY - e.touches[1].clientY);
      scaleStart = scale;
    }, { passive: true });
    overlay.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2 || !pinchStart) return;
      e.preventDefault();
      var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                         e.touches[0].clientY - e.touches[1].clientY);
      var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      var target = Math.min(MAX, Math.max(MIN, scaleStart * (d / pinchStart)));
      zoomAt(target / scale, cx, cy);
    }, { passive: false });
    overlay.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pinchStart = 0;
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-ws-zoom]');
    if (!el) return;
    var src = el.getAttribute('data-ws-zoom');
    if (!src) return;
    e.preventDefault();
    open(src);
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay) return;
    if (e.key === 'Escape') close();
    if (e.key === '0') reset();
  });

  css();
})();
